import { render, staticRenderFns } from "./Isabella.vue?vue&type=template&id=214277d3&"
import script from "./Isabella.vue?vue&type=script&lang=js&"
export * from "./Isabella.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports